import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { MdArrowBack } from "react-icons/md";
import * as Yup from "yup";
import { AiOutlineDelete } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import DatePicker from "react-datepicker";
import "react-phone-input-2/lib/style.css";
import { FaChevronDown } from "react-icons/fa6";
import { IoCalendarOutline } from "react-icons/io5";
import ConfirmationModal from "../../components/Appointment/ConfirmationModal";
import { MultiSelect } from "primereact/multiselect";
import HrEnablementPanel from "./HrEnablementPanel";
import ModuleEnablementPanel from "./ModuleEnablementPanel";

const AddVendor = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const isEditing = Boolean(id);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredTradeIndex, setHoveredTradeIndex] = useState(null);
  const [hoveredVendorIndex, setHoveredVendorIndex] = useState(null);
  const [buildingPhotos, setBuildingPhotos] = useState([]);
  const [tradeLicensePhotos, setTradeLicensePhotos] = useState([]);
  const [vendorProfilePhotos, setVendorProfilePhotos] = useState([]);
  const [services, setServices] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [subscriptionTypes, setSubscriptionTypes] = useState([]);
  const [initialValues, setInitialValues] = useState({
    vendorName: "",
    vendorType: "",
    contact: "",
    email: "",
    workingHoursStart: "",
    workingHoursEnd: "",
    consultationFeesFrom: "",
    consultationFeesTo: "",
    subscriptionType: "",
    aboutUs: "",
    street: "",
    city: "",
    emirate: "",
    country: "",
    latitude: "",
    longitude: "",
    bankName: "",
    accountNumber: "",
    bankIFSC: "",
    bankaccountHolderName: "",
    accountHolderName: "",
    tradersLicenseNumber: "",
    licenseExpiryDate: "",
    subscriptionEndDate: "",
    status: "",
  });

  const IMAGE_SIZE_LIMIT = 500 * 1024;
  const IMAGE_DIMENSIONS_WIDTH = 400;
  const IMAGE_DIMENSIONS_HEIGHT = 220;
  const LOGO_DIMENSIONS_WIDTH = 180;
  const LOGO_DIMENSIONS_HEIGHT = 180;
  const MAX_IMAGES = 8;

  const [showConflictModal, setShowConflictModal] = useState(false);
  const [pendingWorkingHours, setPendingWorkingHours] = useState(null); // { start, end }
  const [submitAction, setSubmitAction] = useState(null); // store Formik helpers if needed
  const [pendingSubmit, setPendingSubmit] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [allservices, setAllservices] = useState([]);

  console.log("selectedService-----", selectedService);

  // Validation Schema
  const vendorSchema = Yup.object().shape({
    vendorName: Yup.string()
      .required("Vendor name is required")
      .min(2, "Vendor name must be at least 2 characters")
      .max(20, "Vendor name must not exceed 20 characters"),

    vendorType: Yup.string().required("Vendor type is required"),

    contact: Yup.string()
      .required("Contact number is required")
      .matches(/^[0-9]+$/, "Contact number must be numeric")
      .test("country-specific-length", function (value) {
        if (!value) return true;
        const cleanedValue = value.replace(/\D/g, "");
        if (cleanedValue.startsWith("91")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message:
                "Please enter a valid Indian mobile number (min 10 digits)",
            })
          );
        }
        if (cleanedValue.startsWith("971")) {
          return (
            cleanedValue.length >= 12 ||
            this.createError({
              message: "Please enter a valid UAE mobile number (min 9 digits)",
            })
          );
        }
        // Default: minimum 10 digits (including country code)
        return (
          cleanedValue.length >= 10 ||
          this.createError({
            message: "Please enter a valid mobile number (min 10 digits)",
          })
        );
      }),

    email: Yup.string()
      .required("Email is required")
      .email("Please enter a valid email address")
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Please enter a valid email address"
      ),

    workingHoursStart: Yup.string().required("Start time is required"),

    workingHoursEnd: Yup.string()
      .required("End time is required")
      .test(
        "is-after-start",
        "End time must be after start time",
        function (value) {
          const { workingHoursStart } = this.parent;
          if (!workingHoursStart || !value) return true;
          return value > workingHoursStart;
        }
      ),

    consultationFeesFrom: Yup.number()
      .required("Consultation fee from is required")
      .min(0, "Consultation fee must be positive"),

    consultationFeesTo: Yup.number()
      .required("Consultation fee to is required")
      .min(0, "Consultation fee must be positive")
      .test(
        "is-greater-than-from",
        "To fee must be greater than From fee",
        function (value) {
          const { consultationFeesFrom } = this.parent;
          if (value == null || consultationFeesFrom == null) return true;
          return value > consultationFeesFrom;
        }
      ),

    subscriptionType: Yup.string().required("Subscription type is required"),

    aboutUs: Yup.string()
      .required("About us is required")
      .min(10, "About us must be at least 10 characters")
      .max(500, "About us must not exceed 500 characters"),

    street: Yup.string()
      .required("Street address is required")
      .min(5, "Street address must be at least 5 characters")
      .max(100, "Street address must not exceed 100 characters"),

    city: Yup.string().test(
      "city-validation",
      "City is required",
      function (value) {
        const { emirate } = this.parent;
        if (emirate && cities.length > 0) {
          return !!value;
        }
        return true;
      }
    ),

    emirate: Yup.string().required("Emirate is required"),

    country: Yup.string().required("Country is required"),
    latitude: Yup.string().test(
      "is-valid-latitude",
      "Invalid latitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -90 && numValue <= 90;
      }
    ),
    longitude: Yup.string().test(
      "is-valid-longitude",
      "Invalid longitude value",
      (value) => {
        if (!value) return true;
        const numValue = parseFloat(value);
        return !isNaN(numValue) && numValue >= -180 && numValue <= 180;
      }
    ),

    bankName: Yup.string()
      .min(2, "Bank name must be at least 2 characters")
      .max(50, "Bank name must not exceed 50 characters"),

    accountNumber: Yup.string()
      .matches(/^[0-9]+$/, "Account number must be numeric")
      .min(5, "Account number must be at least 5 digits")
      .max(20, "Account number must not exceed 20 digits"),

    bankIFSC: Yup.string()
      .matches(
        /^[A-Z0-9]+$/,
        "IFSC code must contain only uppercase letters and numbers"
      )
      .min(8, "IFSC code must be at least 8 characters")
      .max(11, "IFSC code must not exceed 11 characters"),

    bankaccountHolderName: Yup.string()
      .min(2, "Account holder name must be at least 2 characters")
      .max(50, "Account holder name must not exceed 50 characters")
      .matches(
        /^[a-zA-Z\s]*$/,
        "Account holder name must contain only letters and spaces"
      ),

    accountHolderName: Yup.string()
      .required("Account holder name is required")
      .min(2, "Account holder name must be at least 2 characters")
      .max(50, "Account holder name must not exceed 50 characters")
      .matches(
        /^[a-zA-Z\s]*$/,
        "Account holder name must contain only letters and spaces"
      )
      .test(
        "matches-bank-account",
        "Account holder name must match bank account holder name",
        function (value) {
          const { bankaccountHolderName } = this.parent;
          if (!bankaccountHolderName || !value) return true;
          return value.toLowerCase() === bankaccountHolderName.toLowerCase();
        }
      ),

    tradersLicenseNumber: Yup.string()
      .required("Traders license number is required")
      .min(5, "License number must be at least 5 characters")
      .max(20, "License number must not exceed 20 characters"),

    licenseExpiryDate: Yup.date()
      .required("License expiry date is required")
      .min(new Date(), "License expiry date must be in the future"),

    subscriptionEndDate: Yup.date()
      .required("Subscription end date is required")
      .min(new Date(), "Subscription end date must be in the future"),

    status: Yup.string().when("$isEditing", {
      is: true,
      then: Yup.string().required("Status is required"),
    }),
  });

  // Add this new function to convert URL to base64
  const convertUrlToBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting URL to base64:", error);
      return null;
    }
  };

  // Fetch services
  const fetchServices = async () => {
    try {
      const token = localStorage.getItem("token");
      // const response = await apicall.get("services?category_id=2", {
      const response = await apicall.get("services", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setServices(response.data);
        let s1 = response.data?.map((ele) => {
          return {
            service_id: ele?.service_id,
            name: ele?.name,
          };
        });
        setAllservices(s1);
        setSelectedService([s1[0]]);

        // Set default vendor type if not editing
        if (!id && response.data.length > 0) {
          setInitialValues((prev) => ({
            ...prev,
            vendorType: response.data[0].service_id.toString(),
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching services:", error);
      toast.error("Failed to fetch services");
    }
  };

  const fetchSubscriptionTypes = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get("membershipPlans", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setSubscriptionTypes(response.data);
      }
    } catch (error) {
      console.error("Error fetching subscription types:", error);
      toast.error("Failed to fetch subscription types");
    }
  };

  const fetchCountries = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get("country", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success) {
        const countriesData = Array.isArray(response.data)
          ? response.data
          : response.data?.countries || [];

        setCountries(countriesData);

        // Find UAE in the countries list
        const uaeCountry = countriesData.find(
          (country) =>
            country.name.toLowerCase() === "united arab emirates" ||
            country.name.toLowerCase() === "uae"
        );

        // If UAE is found, set it as default
        if (uaeCountry) {
          setInitialValues((prev) => ({
            ...prev,
            country: uaeCountry.country_id.toString(),
          }));
          // Fetch states for UAE
          fetchStates(uaeCountry.country_id.toString());
        } else if (countriesData.length > 0) {
          // Fallback to first country if UAE not found
          setInitialValues((prev) => ({
            ...prev,
            country: countriesData[0].country_id.toString(),
          }));
          fetchStates(countriesData[0].country_id.toString());
        }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      toast.error("Failed to fetch countries");
    }
  };
  const fetchStates = async (countryId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get(`state/${countryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setStates(response.data);
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to fetch states");
      setStates([]);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apicall.get(`city/${stateId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.success && response.data) {
        setCities(response.data);
      } else {
        setCities([]);
      }
    } catch (error) {
      toast.error("Failed to fetch cities");
      setCities([]);
    }
  };

  const handleCountryChange = (e, setFieldValue) => {
    const countryId = e.target.value;

    setFieldValue("country", countryId);
    if (countryId) {
      fetchStates(countryId);
      // Reset state and city when country changes
      setStates([]);
      setCities([]);
      setFieldValue("emirate", "");
      setFieldValue("city", "");
    } else {
      setStates([]);
      setCities([]);
    }
  };

  const handleStateChange = (e, setFieldValue) => {
    const stateId = e.target.value;

    setFieldValue("emirate", stateId);
    if (stateId) {
      fetchCities(stateId);
      // Reset city when state changes
      setCities([]);
      setFieldValue("city", "");
    } else {
      setCities([]);
    }
  };

  // Fetch vendor details if editing
  useEffect(() => {
    const initializeData = async () => {
      try {
        await Promise.all([
          fetchServices(),
          fetchCountries(),
          fetchSubscriptionTypes(),
        ]);
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize form data");
      }
    };

    initializeData();

    const fetchVendorDetails = async () => {
      if (!id) return;
      setLoading(true);
      setError(null);
      try {
        const response = await apicall.get(`get_vendor_details?id=${id}`);
        if (response.success && response.data?.length > 0) {
          let vendor_type = response.data?.map((ele) => {
            return { service_id: ele?.service_id, name: ele?.service_name };
          });
          setSelectedService(vendor_type);

          const vendorData = response.data[0];

          // Fetch states for the selected country
          if (vendorData.country) {
            await fetchStates(vendorData.country);
          }

          // Fetch cities for the selected state
          if (vendorData.state) {
            await fetchCities(vendorData.state);
          }

          // Convert CloudFront URLs to base64 for images
          let profileImageBase64 = null;
          let officeImagesBase64 = [];
          let tradeLicenseImagesBase64 = [];

          if (vendorData.profile_image) {
            profileImageBase64 = await convertUrlToBase64(
              vendorData.profile_image
            );
          }

          if (Array.isArray(vendorData.office_images)) {
            // Filter out null values before converting to base64
            const validOfficeImages = vendorData.office_images.filter(
              (url) => url !== null
            );
            if (validOfficeImages.length > 0) {
              officeImagesBase64 = await Promise.all(
                validOfficeImages.map((url) => convertUrlToBase64(url))
              );
            }
          } else if (vendorData.office_images) {
            officeImagesBase64 = [
              await convertUrlToBase64(vendorData.office_images),
            ];
          }

          if (Array.isArray(vendorData.tradeLicense_image)) {
            // Filter out null values before converting to base64
            const validTradeLicenseImages =
              vendorData.tradeLicense_image.filter((url) => url !== null);
            if (validTradeLicenseImages.length > 0) {
              tradeLicenseImagesBase64 = await Promise.all(
                validTradeLicenseImages.map((url) => convertUrlToBase64(url))
              );
            }
          } else if (vendorData.tradeLicense_image) {
            tradeLicenseImagesBase64 = [
              await convertUrlToBase64(vendorData.tradeLicense_image),
            ];
          }

          setInitialValues({
            vendorName: vendorData.first_name || "",
            vendorType: vendorData.service_id
              ? vendorData.service_id.toString()
              : "",
            contact: vendorData.phone_number || "",
            email: vendorData.email || "",
            subscriptionType: vendorData.plan || "",
            aboutUs: vendorData.about_user || "",
            street: vendorData.street || vendorData.address || "",
            city: vendorData.city || "",
            emirate: vendorData.state || "",
            country: vendorData.country || "",
            latitude: vendorData.latitude || "",
            longitude: vendorData.longitude || "",
            bankName: vendorData.bank_name || "",
            consultationFeesFrom: vendorData.fee_from || "",
            consultationFeesTo: vendorData.fee_to || "",
            bankaccountHolderName: vendorData.name_on_bank || "",
            accountNumber: vendorData.bank_account_number || "",
            bankIFSC: vendorData.IFSC || "",
            accountHolderName: vendorData.name_on_bank || "",
            tradersLicenseNumber: vendorData.tradeLicense_number || "",
            licenseExpiryDate: vendorData.license_exp_date
              ? new Date(vendorData.license_exp_date)
                  .toISOString()
                  .split("T")[0]
              : "",
            subscriptionEndDate: vendorData.end_date
              ? new Date(vendorData.end_date).toISOString().split("T")[0]
              : "",
            workingHoursStart: vendorData.working_hours_start || "",
            workingHoursEnd: vendorData.working_hours_end || "",
            status: vendorData.status?.toLowerCase() === "active" ? "1" : "0",
          });

          // Set images with base64 data
          if (profileImageBase64) {
            setVendorProfilePhotos([
              {
                id: 1,
                url: vendorData.profile_image,
                file: new File([], "profile.jpg"),
                isExisting: true,
                base64: profileImageBase64,
                preview: `data:image/jpeg;base64,${profileImageBase64}`,
              },
            ]);
          }

          if (officeImagesBase64.length > 0) {
            setBuildingPhotos(
              officeImagesBase64.map((base64, idx) => ({
                id: idx + 1,
                url: Array.isArray(vendorData.office_images)
                  ? vendorData.office_images.filter((url) => url !== null)[idx]
                  : vendorData.office_images,
                file: new File([], "office.jpg"),
                isExisting: true,
                base64: base64,
                preview: `data:image/jpeg;base64,${base64}`,
              }))
            );
          }

          if (tradeLicenseImagesBase64.length > 0) {
            setTradeLicensePhotos(
              tradeLicenseImagesBase64.map((base64, idx) => ({
                id: idx + 1,
                url: Array.isArray(vendorData.tradeLicense_image)
                  ? vendorData.tradeLicense_image.filter((url) => url !== null)[
                      idx
                    ]
                  : vendorData.tradeLicense_image,
                file: new File([], "license.jpg"),
                isExisting: true,
                base64: base64,
                preview: `data:image/jpeg;base64,${base64}`,
              }))
            );
          }
        } else {
          throw new Error(response.message || "No vendor data found");
        }
      } catch (err) {
        console.error("Fetch error:", err);
        toast.error(err.message || "Failed to fetch vendor");
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchVendorDetails();
  }, [id]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleBuildingPhotoUpload = (e) => {
    const files = Array.from(e.target.files);

    if (buildingPhotos.length + files.length > MAX_IMAGES) {
      toast.error(`Maximum ${MAX_IMAGES} images allowed for building photos`);
      return;
    }

    const validFiles = [];
    let processedCount = 0;

    files.forEach((file) => {
      if (file.size > IMAGE_SIZE_LIMIT) {
        toast.error("Image file is too large");
        return;
      }

      let newImage = new Image();
      newImage.src = URL.createObjectURL(file);
      newImage.onload = function () {
        let w = newImage.width;
        let h = newImage.height;
        if (w <= IMAGE_DIMENSIONS_WIDTH && h <= IMAGE_DIMENSIONS_HEIGHT) {
          validFiles.push({
            id: Math.random(),
            url: URL.createObjectURL(file),
            file,
            isExisting: false,
          });
        } else {
          toast.error("Image dimensions are too large");
        }

        processedCount++;
        if (processedCount === files.length) {
          if (validFiles.length > 0) {
            setBuildingPhotos((prev) => [...prev, ...validFiles]);
          }
        }
      };
    });
  };

  const handleTradeLicensePhotoUpload = (e) => {
    const files = Array.from(e.target.files);

    if (tradeLicensePhotos.length + files.length > MAX_IMAGES) {
      toast.error(
        `Maximum ${MAX_IMAGES} images allowed for trade license photos`
      );
      return;
    }

    const validFiles = [];
    let processedCount = 0;

    files.forEach((file) => {
      if (file.size > IMAGE_SIZE_LIMIT) {
        toast.error("Image file is too large");
        return;
      }

      let newImage = new Image();
      newImage.src = URL.createObjectURL(file);
      newImage.onload = function () {
        let w = newImage.width;
        let h = newImage.height;
        if (w <= IMAGE_DIMENSIONS_WIDTH && h <= IMAGE_DIMENSIONS_HEIGHT) {
          validFiles.push({
            id: Math.random(),
            url: URL.createObjectURL(file),
            file,
            isExisting: false,
          });
        } else {
          toast.error("Image dimensions are too large");
        }

        processedCount++;
        if (processedCount === files.length) {
          if (validFiles.length > 0) {
            setTradeLicensePhotos((prev) => [...prev, ...validFiles]);
          }
        }
      };
    });
  };

  const handleVendorlogo = (e) => {
    const files = Array.from(e.target.files);

    if (files.length > 1) {
      toast.error("Only one logo image is allowed");
      return;
    }

    const file = files[0];
    if (file.size > IMAGE_SIZE_LIMIT) {
      toast.error("Image file is too large");
      return;
    }

    let newImage = new Image();
    newImage.src = URL.createObjectURL(file);
    newImage.onload = function () {
      let w = newImage.width;
      let h = newImage.height;
      if (w <= LOGO_DIMENSIONS_WIDTH && h <= LOGO_DIMENSIONS_HEIGHT) {
        setVendorProfilePhotos([
          {
            id: Math.random(),
            url: URL.createObjectURL(file),
            file,
            isExisting: false,
          },
        ]);
      } else {
        toast.error("Logo dimensions are too large");
      }
    };
  };

  const handleRemovePhoto = (idOrIndex, type) => {
    if (type === "vendor") {
      setVendorProfilePhotos((prev) =>
        prev.filter((photo, idx) => photo.id !== idOrIndex && idx !== idOrIndex)
      );
    } else if (type === "trade") {
      setTradeLicensePhotos((prev) =>
        prev.filter((photo, idx) => photo.id !== idOrIndex && idx !== idOrIndex)
      );
    } else if (type === "building") {
      setBuildingPhotos((prev) =>
        prev.filter((photo, idx) => photo.id !== idOrIndex && idx !== idOrIndex)
      );
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    setError(null);
    if (selectedService?.length === 0) {
      toast.error("Select vendor type to proceed.");
      setLoading(false);
    } else {
      try {
        if (
          !values.skipConflictCheck &&
          isEditing &&
          (values.workingHoursStart !== initialValues.workingHoursStart ||
            values.workingHoursEnd !== initialValues.workingHoursEnd)
        ) {
          const today = new Date();
          const startDate = today.toISOString().split("T")[0];
          // Fetch all future appointments for this vendor
          const response = await apicall.get(
            `get_booking_details/range/${startDate}/2099-12-31/${id}`
          );
          if (response.success && Array.isArray(response.data)) {
            // Check if any appointment is outside the new working hours
            const startTime = values.workingHoursStart;
            const endTime = values.workingHoursEnd;
            const isOutside = response.data.some((appt) => {
              // appt.booking_time is in 'HH:mm' format
              if (!appt.booking_time) return false;
              return (
                appt.booking_time < startTime || appt.booking_time >= endTime
              );
            });
            if (isOutside) {
              setShowConflictModal(true);
              setPendingSubmit({ values, setSubmitting });
              setLoading(false);
              setSubmitting(false);
              return;
            }
          }
        }

        const convertImageToBase64 = (file) => {
          if (!file) return Promise.resolve("");
          if (typeof file === "string") return Promise.resolve(file); // If it's already a base64 string
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result.split(",")[1]);
            reader.onerror = (error) => reject(error);
          });
        };

        // Process images - use existing base64 if available, otherwise convert new files
        const buildingPhotoBase64Array = await Promise.all(
          buildingPhotos.map((photo) =>
            photo.isExisting ? photo.base64 : convertImageToBase64(photo.file)
          )
        );

        const tradeLicensePhotoBase64Array = await Promise.all(
          tradeLicensePhotos.map((photo) =>
            photo.isExisting ? photo.base64 : convertImageToBase64(photo.file)
          )
        );

        // Handle profile image - check if it exists and has base64 data
        let vendorLogoBase64 = "";
        if (vendorProfilePhotos.length > 0) {
          const profilePhoto = vendorProfilePhotos[0];
          if (profilePhoto.isExisting && profilePhoto.base64) {
            vendorLogoBase64 = profilePhoto.base64;
          } else if (profilePhoto.file) {
            vendorLogoBase64 = await convertImageToBase64(profilePhoto.file);
          }
        }

        // Format dates
        const formatDate = (dateString) => {
          if (!dateString) return "";
          const date = new Date(dateString);
          return date.toISOString().split("T")[0];
        };

        const data = {
          role: 3,
          first_name: values.vendorName,
          middle_name: "",
          last_name: "",
          email: values.email,
          phone_number: values.contact,
          gender: 0,
          country: parseInt(values.country),
          state: parseInt(values.emirate),
          city: parseInt(values.city),
          address: values.street,
          latitude: values.latitude || "",
          longitude: values.longitude || "",
          created: "",
          modified: "",
          is_active: values.status === "0" ? 0 : 1,
          otp: "",
          start_date: formatDate(new Date()),
          end_date: formatDate(values.subscriptionEndDate),
          stripe_cust_id: "",
          invitation_code: "",
          referral_code: "",
          office_images: buildingPhotoBase64Array,
          about_user: values.aboutUs,
          dob: "0000-00-00",
          profile_image: vendorLogoBase64,
          // service: parseInt(values.vendorType),
          service: selectedService?.map((ele) => parseInt(ele?.service_id)),
          plan: parseInt(values.subscriptionType),
          invoice_duration: 0,
          bank_name: values.bankName,
          IFSC: values.bankIFSC,
          name_on_bank: values.bankaccountHolderName,
          bank_account_number: values.accountNumber,
          tradeLicense_number: values.tradersLicenseNumber,
          license_exp_date: formatDate(values.licenseExpiryDate),
          tradeLicense_image: tradeLicensePhotoBase64Array,
          working_hours_start: values.workingHoursStart || null,
          working_hours_end: values.workingHoursEnd || null,
          fee_from: parseInt(values.consultationFeesFrom),
          fee_to: parseInt(values.consultationFeesTo),
          account_holder_name: values.bankaccountHolderName,
        };
        const payload = isEditing ? { id: id, ...data } : { ...data };

        console.log("payload--------", payload);

        const res = await apicall.post(payload, "vendor_register");

        if (res && (res.status === 200 || res.success)) {
          toast.success(
            isEditing
              ? "Vendor updated successfully"
              : "Vendor added successfully",
            {
              autoClose: 1500,
              onClose: () => navigate("/vendors"),
            }
          );
        } else {
          throw new Error(res?.message || "Failed to save vendor");
        }
      } catch (e) {
        console.error("Submission error:", e);
        toast.error(e.message || "An error occurred while saving");
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    }
  };

  if (loading && isEditing) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "400px" }}
      >
        <Spinner animation="border" variant="danger" />
      </div>
    );
  }

  return (
    <div className="px-3">
      <div className="d-flex align-items-center mb-3 pt-3">
        <Button
          variant="link"
          className="text-dark text-decoration-none p-0 d-flex align-items-center back-button"
          onClick={handleBack}
        >
          <MdArrowBack size={20} /> BACK
        </Button>
      </div>

      <div className="form-container">
        <h4 className="mb-4 page-heading">
          {isEditing ? "Edit Vendor" : "Add Vendor"}
        </h4>

        <Formik
          initialValues={initialValues}
          validationSchema={vendorSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            setFieldError,
          }) => (
            <form onSubmit={handleSubmit}>
              {/* Basic Details Section */}
              <div className="mb-4">
                <h6 className="mb-4 section-heading">Basic Details</h6>
                <Row className="mb-4">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Vendor Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="vendorName"
                        placeholder="Enter vendor name"
                        value={values.vendorName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.vendorName && errors.vendorName}
                        className={`form-input ${
                          values.vendorName === "" ? "placeholder-style" : ""
                        }`}
                      />
                      {touched.vendorName && errors.vendorName && (
                        <div className="invalid-feedback d-block">
                          {errors.vendorName}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Vendor Type</Form.Label>
                      <div>
                        <MultiSelect
                          value={selectedService}
                          onChange={(e) => setSelectedService(e.value)}
                          options={allservices}
                          optionLabel="name"
                          filter
                          filterDelay={400}
                          placeholder="Select Vendor Type"
                          maxSelectedLabels={3}
                          // className="form-control "
                          style={{ width: "100%", height: "40px" }}
                        />
                      </div>

                      {/* <Form.Select
                        name="vendorType"
                        value={values.vendorType}
                        onChange={(e) => {
                          console.log("e-----", e);
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        // multiple
                        isInvalid={touched.vendorType && errors.vendorType}
                        className={`form-input ${
                          values.vendorType === "" ? "placeholder-style" : ""
                        }`}
                      >
                        <option value="">Select vendor type</option>
                        {services.map((service) => (
                          <option
                            key={service.service_id}
                            value={service.service_id}
                          >
                            {service.name}
                          </option>
                        ))}
                      </Form.Select>
                      {touched.vendorType && errors.vendorType && (
                        <div className="invalid-feedback d-block">
                          {errors.vendorType}
                        </div>
                      )} */}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Contact</Form.Label>
                      <PhoneInput
                        country={"ae"}
                        onlyCountries={["ae", "in"]}
                        value={values.contact}
                        onChange={(value) => {
                          const cleanedValue = value.replace(/\D/g, "");
                          let isValid = false;
                          let errorMsg =
                            "Please enter a valid mobile number (min 8 digits)";
                          if (cleanedValue.startsWith("91")) {
                            isValid = cleanedValue.length >= 12;
                            errorMsg =
                              "Please enter a valid Indian mobile number (min 10 digits)";
                          } else if (cleanedValue.startsWith("971")) {
                            isValid = cleanedValue.length >= 12;
                            errorMsg =
                              "Please enter a valid UAE mobile number (min 9 digits)";
                          } else {
                            isValid = cleanedValue.length >= 10; // Default for other countries
                          }

                          setFieldValue("contact", cleanedValue);

                          if (!isValid) {
                            setFieldError("contact", errorMsg);
                          } else {
                            setFieldError("contact", undefined);
                          }
                          setFieldTouched("contact", true, false);
                        }}
                        inputStyle={{
                          width: "100%",
                          height: "40px",
                          backgroundColor: "white",
                          borderColor:
                            touched.contact && errors.contact
                              ? "#dc3545"
                              : "#E9ECEF",
                        }}
                        inputProps={{
                          name: "contact",
                          required: true,
                        }}
                      />
                      {touched.contact && errors.contact && (
                        <div className="invalid-feedback d-block">
                          {errors.contact}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-3 mt-1">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter valid email address"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.email && errors.email}
                        className="form-inpt"
                      />
                      {touched.email && errors.email && (
                        <div className="invalid-feedback d-block">
                          {errors.email}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Working Hours</Form.Label>
                      <div className="d-flex gap-2">
                        <Form.Select
                          name="workingHoursStart"
                          value={values.workingHoursStart}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.workingHoursStart &&
                            errors.workingHoursStart
                          }
                          className={`form-input ${
                            values.workingHoursStart === ""
                              ? "placeholder-style"
                              : ""
                          }`}
                        >
                          <option value="">Start time</option>
                          {Array.from({ length: 24 }, (_, i) => (
                            <option
                              key={i}
                              value={i.toString().padStart(2, "0") + ":00"}
                            >
                              {i.toString().padStart(2, "0") + ":00"}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Select
                          name="workingHoursEnd"
                          value={values.workingHoursEnd}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.workingHoursEnd && errors.workingHoursEnd
                          }
                          className={`form-input ${
                            values.workingHoursEnd === ""
                              ? "placeholder-style"
                              : ""
                          }`}
                          style={{ height: "40px" }}
                        >
                          <option value="">End time</option>
                          {Array.from({ length: 24 }, (_, i) => (
                            <option
                              key={i}
                              value={i.toString().padStart(2, "0") + ":00"}
                            >
                              {i.toString().padStart(2, "0") + ":00"}
                            </option>
                          ))}
                        </Form.Select>
                      </div>
                      {touched.workingHoursStart &&
                        errors.workingHoursStart && (
                          <div className="invalid-feedback d-block">
                            {errors.workingHoursStart}
                          </div>
                        )}
                      {touched.workingHoursEnd && errors.workingHoursEnd && (
                        <div className="invalid-feedback d-block">
                          {errors.workingHoursEnd}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Consultation Fees</Form.Label>
                      <div className="d-flex gap-2">
                        <Form.Control
                          type="text"
                          name="consultationFeesFrom"
                          value={values.consultationFeesFrom}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.consultationFeesFrom &&
                            errors.consultationFeesFrom
                          }
                          className="form-input"
                          placeholder="From"
                        />
                        <Form.Control
                          type="text"
                          name="consultationFeesTo"
                          value={values.consultationFeesTo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={
                            touched.consultationFeesTo &&
                            errors.consultationFeesTo
                          }
                          className="form-input"
                          placeholder="To"
                        />
                      </div>
                      {touched.consultationFeesFrom &&
                        errors.consultationFeesFrom && (
                          <div className="invalid-feedback d-block">
                            {errors.consultationFeesFrom}
                          </div>
                        )}
                      {touched.consultationFeesTo &&
                        errors.consultationFeesTo && (
                          <div className="invalid-feedback d-block">
                            {errors.consultationFeesTo}
                          </div>
                        )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-3 mt-1">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Subscription Type</Form.Label>
                      <Form.Select
                        name="subscriptionType"
                        value={values.subscriptionType}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.subscriptionType && errors.subscriptionType
                        }
                        className={`form-input ${
                          values.subscriptionType === ""
                            ? "placeholder-style"
                            : ""
                        }`}
                      >
                        <option value="">Select Subscription</option>
                        {subscriptionTypes.map((subscription) => (
                          <option
                            key={subscription.id}
                            value={subscription.membership_plan_id}
                          >
                            {subscription.name} ({subscription.leads_per_month}{" "}
                            leads/month)
                          </option>
                        ))}
                      </Form.Select>
                      {touched.subscriptionType && errors.subscriptionType && (
                        <div className="invalid-feedback d-block">
                          {errors.subscriptionType}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Upload office/building Photo</Form.Label>
                      <div className="d-flex align-items-center">
                        <div
                          className="flex-grow-1 border form-input rounded-start px-3 d-flex align-items-center justify-content-between"
                          style={{ height: "40px", fontSize: "14px" }}
                        >
                          <span className="secondary-text">Upload image</span>
                          <span className="text-dark">TO</span>
                        </div>
                        <Button
                          variant="danger"
                          onClick={() =>
                            document.getElementById("buildingPhoto").click()
                          }
                          className="rounded-end btn-outline-border"
                          style={{
                            fontSize: "14px",
                            height: "40px",
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                          }}
                          disabled={buildingPhotos.length >= MAX_IMAGES}
                        >
                          Upload Photo
                        </Button>
                        <input
                          type="file"
                          id="buildingPhoto"
                          className="d-none"
                          onChange={handleBuildingPhotoUpload}
                          accept="image/*"
                          multiple
                        />
                      </div>
                      <div className="mt-2">
                        <label className="text-muted small">
                          Max Size: {IMAGE_SIZE_LIMIT / 1024} KB
                          <br />
                          Dimensions: {IMAGE_DIMENSIONS_WIDTH}w x{" "}
                          {IMAGE_DIMENSIONS_HEIGHT}h<br />
                          Max Images: {MAX_IMAGES} ({buildingPhotos.length}/
                          {MAX_IMAGES} uploaded)
                        </label>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <div className="d-flex gap-2 flex-wrap">
                        {buildingPhotos.map((photo, index) => (
                          <div
                            key={index}
                            className="position-relative"
                            style={{
                              width: "60px",
                              height: "60px",
                              overflow: "hidden",
                            }}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                          >
                            <img
                              src={photo.url}
                              alt={`Building ${index + 1}`}
                              className="rounded-1"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            {hoveredIndex === index && (
                              <div className="position-absolute top-50 start-50 translate-middle">
                                <AiOutlineDelete
                                  onClick={() =>
                                    handleRemovePhoto(photo.id, "building")
                                  }
                                  style={{
                                    fontSize: "20px",
                                    color: "white",
                                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                                    borderRadius: "50%",
                                    padding: "4px",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="g-3 mt-1">
                  <Col md={12}>
                    <Form.Group>
                      <Form.Label>About Us</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="aboutUs"
                        placeholder="Enter brief description about the vendor"
                        value={values.aboutUs}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.aboutUs && errors.aboutUs}
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.aboutUs && errors.aboutUs && (
                        <div className="invalid-feedback d-block">
                          {errors.aboutUs}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Address Section */}
              <div className="mb-4">
                <h6 className="section-heading mb-3">Address</h6>
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Street/House Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="street"
                        placeholder="Enter street address"
                        value={values.street}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.street && errors.street}
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.street && errors.street && (
                        <div className="invalid-feedback d-block">
                          {errors.street}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Country</Form.Label>
                      <Form.Select
                        name="country"
                        value={values.country}
                        onChange={(e) => handleCountryChange(e, setFieldValue)}
                        onBlur={handleBlur}
                        isInvalid={touched.country && errors.country}
                        className={`form-input ${
                          values.country === "" ? "placeholder-style" : ""
                        }`}
                        style={{
                          height: "40px",
                          backgroundColor: "white",
                          border: "1px solid #E9ECEF",
                        }}
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option
                            key={country.country_id}
                            value={country.country_id}
                          >
                            {country.name}
                          </option>
                        ))}
                      </Form.Select>
                      {touched.country && errors.country && (
                        <div className="invalid-feedback d-block">
                          Please select a country
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Emirate</Form.Label>
                      <Form.Select
                        name="emirate"
                        value={values.emirate}
                        onChange={(e) => handleStateChange(e, setFieldValue)}
                        onBlur={handleBlur}
                        isInvalid={touched.emirate && errors.emirate}
                        className={`form-input ${
                          values.emirate === "" ? "placeholder-style" : ""
                        }`}
                        style={{
                          height: "40px",
                          backgroundColor: "white",
                          border:
                            touched.emirate && errors.emirate
                              ? "1px solid #dc3545"
                              : "1px solid #E9ECEF",
                        }}
                      >
                        <option value="">Select Emirate</option>
                        {states.map((state) => (
                          <option key={state.state_id} value={state.state_id}>
                            {state.name}
                          </option>
                        ))}
                      </Form.Select>
                      {touched.emirate && errors.emirate && (
                        <div className="invalid-feedback d-block">
                          {errors.emirate}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>City</Form.Label>
                      <Form.Select
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.city && errors.city}
                        className={`form-input ${
                          values.city === "" ? "placeholder-style" : ""
                        }`}
                        style={{
                          height: "40px",
                          backgroundColor: "white",
                          border:
                            touched.city && errors.city
                              ? "1px solid #dc3545"
                              : "1px solid #E9ECEF",
                        }}
                      >
                        <option value="">Select City</option>
                        {cities.map((city) => (
                          <option key={city.city_id} value={city.city_id}>
                            {city.name}
                          </option>
                        ))}
                      </Form.Select>
                      {touched.city && errors.city && (
                        <div className="invalid-feedback d-block">
                          {errors.city}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Longitude and Latitude</Form.Label>
                      <Row className="g-2">
                        <Col>
                          <Form.Control
                            type="text"
                            name="latitude"
                            placeholder="Latitude"
                            value={values.latitude}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.latitude && errors.latitude}
                            className="form-input"
                            style={{ fontSize: "14px", height: "40px" }}
                          />
                          {touched.latitude && errors.latitude && (
                            <div className="invalid-feedback d-block">
                              {errors.latitude}
                            </div>
                          )}
                        </Col>
                        <Col>
                          <Form.Control
                            type="text"
                            name="longitude"
                            placeholder="Longitude"
                            value={values.longitude}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.longitude && errors.longitude}
                            className="form-input"
                            style={{ fontSize: "14px", height: "40px" }}
                          />
                          {touched.longitude && errors.longitude && (
                            <div className="invalid-feedback d-block">
                              {errors.longitude}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Bank Details Section */}
              <div className="mb-4">
                <h6 className="section-heading mb-3">Bank Details</h6>
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Vendor's Bank Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="bankName"
                        placeholder="Enter bank name"
                        value={values.bankName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.bankName && errors.bankName}
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.bankName && errors.bankName && (
                        <div className="invalid-feedback d-block">
                          {errors.bankName}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Vendor's Bank Account Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="accountNumber"
                        placeholder="Enter bank account number"
                        value={values.accountNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.accountNumber && errors.accountNumber
                        }
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.accountNumber && errors.accountNumber && (
                        <div className="invalid-feedback d-block">
                          {errors.accountNumber}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Vendor's Bank Swift Code</Form.Label>
                      <Form.Control
                        type="text"
                        name="bankIFSC"
                        placeholder="Enter bank Swift code"
                        value={values.bankIFSC}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={touched.bankIFSC && errors.bankIFSC}
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.bankIFSC && errors.bankIFSC && (
                        <div className="invalid-feedback d-block">
                          {errors.bankIFSC}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Name as per the bank account</Form.Label>
                      <Form.Control
                        type="text"
                        name="bankaccountHolderName"
                        placeholder="Enter account holder name"
                        value={values.bankaccountHolderName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.bankaccountHolderName &&
                          errors.bankaccountHolderName
                        }
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.bankaccountHolderName &&
                        errors.bankaccountHolderName && (
                          <div className="invalid-feedback d-block">
                            {errors.bankaccountHolderName}
                          </div>
                        )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Additional Details Section */}
              <div className="mb-0">
                <h6 className="section-heading mb-3">Additional Details</h6>
                <Row className="g-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Account Holder Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="accountHolderName"
                        placeholder="Enter Name"
                        value={values.accountHolderName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.accountHolderName && errors.accountHolderName
                        }
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.accountHolderName &&
                        errors.accountHolderName && (
                          <Form.Control.Feedback type="invalid">
                            {errors.accountHolderName}
                          </Form.Control.Feedback>
                        )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Traders License Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="tradersLicenseNumber"
                        placeholder="Enter trade license number"
                        value={values.tradersLicenseNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isInvalid={
                          touched.tradersLicenseNumber &&
                          errors.tradersLicenseNumber
                        }
                        className="form-input"
                        style={{ height: "40px" }}
                      />
                      {touched.tradersLicenseNumber &&
                        errors.tradersLicenseNumber && (
                          <Form.Control.Feedback type="invalid">
                            {errors.tradersLicenseNumber}
                          </Form.Control.Feedback>
                        )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>License Expiry Date</Form.Label>
                      <div className="position-relative">
                        <DatePicker
                          selected={
                            values.licenseExpiryDate
                              ? new Date(values.licenseExpiryDate)
                              : null
                          }
                          onChange={(date) =>
                            setFieldValue("licenseExpiryDate", date)
                          }
                          onBlur={() =>
                            setFieldTouched("licenseExpiryDate", true)
                          }
                          onFocus={() =>
                            setFieldTouched("licenseExpiryDate", false)
                          } // Reset touched on focus (optional)
                          dateFormat="yyyy-MM-dd"
                          minDate={new Date()}
                          placeholderText="Select date"
                          className={`form-control ${
                            errors.licenseExpiryDate &&
                            touched.licenseExpiryDate
                              ? "is-invalid"
                              : ""
                          }`}
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          dropdownMode="select"
                          peekNextMonth
                          showMonthDropdown
                          wrapperClassName="w-100"
                        />
                        <IoCalendarOutline
                          className="position-absolute end-1 top-50 translate-middle-y text-secondary pe-none text-dark"
                          style={{
                            right:
                              errors.licenseExpiryDate &&
                              touched.licenseExpiryDate
                                ? "1.75rem"
                                : "0.75rem",
                          }}
                        />
                        {/* Show error only if field is touched OR while focused (optional) */}
                        {errors.licenseExpiryDate &&
                          touched.licenseExpiryDate && (
                            <div
                              className="invalid-feedback"
                              style={{
                                display: "block",
                                position: "absolute",
                                bottom: "-20px",
                                left: 0,
                                fontSize: "0.875em",
                                color: "#dc3545",
                              }}
                            >
                              {errors.licenseExpiryDate}
                            </div>
                          )}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="g-3 mt-1">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Subscription End Date</Form.Label>
                      <div className="position-relative">
                        <DatePicker
                          selected={
                            values.subscriptionEndDate
                              ? new Date(values.subscriptionEndDate)
                              : null
                          }
                          onChange={(date) =>
                            setFieldValue("subscriptionEndDate", date)
                          }
                          onBlur={() =>
                            setFieldTouched("subscriptionEndDate", true)
                          }
                          dateFormat="yyyy-MM-dd"
                          minDate={new Date()} // Must be a future date
                          placeholderText="Select date"
                          className={`form-control ${
                            errors.subscriptionEndDate &&
                            touched.subscriptionEndDate
                              ? "is-invalid"
                              : ""
                          }`}
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={100}
                          dropdownMode="select"
                          peekNextMonth
                          showMonthDropdown
                          wrapperClassName="w-100"
                        />
                        <IoCalendarOutline
                          className="position-absolute end-1 top-50 translate-middle-y text-secondary pe-none text-dark"
                          style={{
                            right:
                              errors.subscriptionEndDate &&
                              touched.subscriptionEndDate
                                ? "1.75rem"
                                : "0.75rem",
                          }}
                        />
                        {/* Error message appears below the input */}
                        {errors.subscriptionEndDate &&
                          touched.subscriptionEndDate && (
                            <div
                              className="invalid-feedback d-block"
                              style={{
                                position: "absolute",
                                bottom: "-20px",
                                left: 0,
                                fontSize: "0.875em",
                                color: "#dc3545",
                              }}
                            >
                              {errors.subscriptionEndDate}
                            </div>
                          )}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Upload Trade License Photo</Form.Label>
                      <div className="d-flex align-items-center">
                        <div
                          className="flex-grow-1 border rounded-start px-3 d-flex align-items-center justify-content-between"
                          style={{ height: "40px", fontSize: "14px" }}
                        >
                          <span className="secondary-text">Upload image</span>
                        </div>
                        <Button
                          variant="danger"
                          onClick={() =>
                            document.getElementById("tradeLicensePhoto").click()
                          }
                          className="rounded-end btn-outline-border"
                          style={{
                            fontSize: "14px",
                            height: "40px",
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                          }}
                          disabled={tradeLicensePhotos.length >= MAX_IMAGES}
                        >
                          Upload Photo
                        </Button>
                        <input
                          type="file"
                          id="tradeLicensePhoto"
                          className="d-none"
                          onChange={handleTradeLicensePhotoUpload}
                          accept="image/*"
                          multiple
                        />
                      </div>
                      <div className="mt-2">
                        <label className="text-muted small">
                          Max Size: {IMAGE_SIZE_LIMIT / 1024} KB
                          <br />
                          Dimensions: {IMAGE_DIMENSIONS_WIDTH}w x{" "}
                          {IMAGE_DIMENSIONS_HEIGHT}h<br />
                          Max Images: {MAX_IMAGES} ({tradeLicensePhotos.length}/
                          {MAX_IMAGES} uploaded)
                        </label>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      {/* In the trade license photos display section */}
                      <div className="d-flex gap-2 flex-wrap">
                        {tradeLicensePhotos.map((photo, index) => (
                          <div
                            key={index}
                            className="position-relative"
                            style={{
                              width: "60px",
                              height: "60px",
                              overflow: "hidden",
                            }}
                            onMouseEnter={() => setHoveredTradeIndex(index)}
                            onMouseLeave={() => setHoveredTradeIndex(null)}
                          >
                            <img
                              src={photo.url}
                              alt={`Trade License ${index + 1}`}
                              className="rounded-1"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            {hoveredTradeIndex === index && (
                              <div className="position-absolute top-50 start-50 translate-middle">
                                <AiOutlineDelete
                                  onClick={() =>
                                    handleRemovePhoto(photo.id, "trade")
                                  }
                                  style={{
                                    fontSize: "20px",
                                    color: "white",
                                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                                    borderRadius: "50%",
                                    padding: "4px",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="g-3 mt-1">
                  {isEditing && (
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                          name="status"
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.status && errors.status}
                          className="form-input"
                          style={{
                            height: "40px",
                            backgroundColor: "white",
                            border:
                              touched.status && errors.status
                                ? "1px solid #dc3545"
                                : "1px solid #E9ECEF",
                          }}
                        >
                          <option value="">Select Status</option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </Form.Select>
                        {touched.status && errors.status && (
                          <div className="invalid-feedback d-block">
                            {errors.status}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  )}

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Vendor Logo</Form.Label>
                      <div className="d-flex align-items-center">
                        <div
                          className="flex-grow-1 border rounded-start px-3 d-flex align-items-center justify-content-between text-muted"
                          style={{ height: "40px", fontSize: "14px" }}
                        >
                          <span className="secondary-text">Upload logo</span>
                        </div>
                        <Button
                          variant="danger"
                          onClick={() =>
                            document.getElementById("vendorlogo").click()
                          }
                          className="rounded-end btn-outline-border"
                          style={{
                            fontSize: "14px",
                            height: "40px",
                            borderTopLeftRadius: 0,
                            borderBottomLeftRadius: 0,
                          }}
                          disabled={vendorProfilePhotos.length >= 1}
                        >
                          Upload Logo
                        </Button>
                        <input
                          type="file"
                          id="vendorlogo"
                          className="d-none"
                          onChange={handleVendorlogo}
                          accept="image/*"
                        />
                      </div>
                      <div className="mt-2">
                        <label className="text-muted small">
                          Max Size: {IMAGE_SIZE_LIMIT / 1024} KB
                          <br />
                          Dimensions: {LOGO_DIMENSIONS_WIDTH}w x{" "}
                          {LOGO_DIMENSIONS_HEIGHT}h<br />
                          Only one logo image allowed
                        </label>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <div className="d-flex gap-2 flex-wrap">
                        {vendorProfilePhotos.map((photo, index) => (
                          <div
                            key={index}
                            className="position-relative"
                            style={{
                              width: "60px",
                              height: "60px",
                              overflow: "hidden",
                            }}
                            onMouseEnter={() => setHoveredVendorIndex(index)}
                            onMouseLeave={() => setHoveredVendorIndex(null)}
                          >
                            <img
                              src={photo.preview || photo.url}
                              alt="Vendor Logo"
                              className="rounded-1"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                            {hoveredVendorIndex === index && (
                              <div className="position-absolute top-50 start-50 translate-middle">
                                <AiOutlineDelete
                                  onClick={() =>
                                    handleRemovePhoto(photo.id, "vendor")
                                  }
                                  style={{
                                    fontSize: "20px",
                                    color: "white",
                                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                                    borderRadius: "50%",
                                    padding: "4px",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </div>

              {/* Form Buttons */}
              <div className="d-flex bg-white rounded p-2 mb-0 gap-4">
                <Button
                  variant="light"
                  onClick={() => navigate("/Vendors")}
                  className="custom-btn btn-large"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="danger"
                  disabled={loading || isSubmitting}
                  className="custom-btn btn-large"
                >
                  {loading || isSubmitting ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : isEditing ? (
                    "Update"
                  ) : (
                    "Submit"
                  )}
                </Button>
              </div>
            </form>
          )}
        </Formik>

        {/* Not part of the vendor form itself (own save action, own API) - only shown once the vendor exists. */}
        {isEditing && <HrEnablementPanel vendorId={id} />}
        {isEditing && <ModuleEnablementPanel vendorId={id} />}
      </div>

      <ConfirmationModal
        show={showConflictModal}
        onClose={() => setShowConflictModal(false)}
        title="Change Working Hours?"
        message="Some future appointments are outside the new time range. Do you want to continue and update the working hours?"
        primaryText="Continue"
        secondaryText="Cancel"
        onPrimary={async () => {
          setShowConflictModal(false);
          if (pendingSubmit) {
            await handleSubmit(
              { ...pendingSubmit.values, skipConflictCheck: true },
              pendingSubmit
            );
          }
        }}
        onSecondary={() => {
          setShowConflictModal(false);
        }}
      />
    </div>
  );
};

export default AddVendor;
